import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AnswerDTO } from '@app/model/answerDTO.model';
import { SlideDTO } from '@app/model/slideDTO.model';
import { HotspotLayoutEnum, QuestionType, SlideHotspotsClickspotsDTO } from 'library-explorer';

@Component({
    selector: 'app-question-hotspot',
    templateUrl: './question-hotspot.component.html',
    styleUrls: ['./question-hotspot.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuestionHotspotComponent),
            multi: true
        }
    ],
    standalone: false
})
export class QuestionHotspotComponent implements ControlValueAccessor {

  @Input() data!: SlideDTO;
  @Input() questionHash?: string;

  public selectedHash?: string;

  public showMarkers = false;

  public markerLayout = HotspotLayoutEnum.LETTER;

  onChange = (data: any) => { };
  onTouched = () => { };

  public onBackgroundLoad(): void {
    this.showMarkers = true;
  }

  public onSpotClick(index: number): void {
    const spot = this.data.hotspots?.clickspots?.[index];
    if (!spot) {
      return;
    }

    this.selectSpot(spot);
  }

  public selectSpot(data: SlideHotspotsClickspotsDTO): void {
    const selectedHash = data?.hash;

    if (selectedHash === this.selectedHash) {
      this.selectedHash = undefined;
      this.onChange(null);
      return;
    }

    this.selectedHash = selectedHash;

    this.onChange({
      type: QuestionType.QUESTION_HOTSPOTS,
      questionHash: this.questionHash,
      answersHash: [selectedHash]
    });
  }

  public writeValue(data: AnswerDTO): void {
    const hash = data?.answersHash;
    this.selectedHash = Array.isArray(hash) ? hash?.[0] : hash;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
